module.exports = new __parcel__URL__("pvp_light_attack_button_disabled.a0f02fbf.png").toString();